import Axios from 'axios'
import { sanitizeApiErrorMessage } from '../network/api-error-message'
import { attachSanctumToken } from './auth-token'
import { attachRateLimitRetry } from '../network/rate-limit'

const axios = Axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
})

attachSanctumToken(axios)

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.data && typeof error.response.data === 'object') {
            const sanitized = sanitizeApiErrorMessage(error.response.data.message)
            if (sanitized !== error.response.data.message) {
                error.response.data.message = sanitized
            }
        }
        return Promise.reject(error)
    },
)

attachRateLimitRetry(axios)

export default axios
